/**
 * TanStack Router: /performance/feedbacks/quick
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceFeedbacksQuickPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceFeedbacksQuickPage from '@/app/performance/feedbacks/quick/page'

/**
 * Route: /performance/feedbacks/quick
 * Layout: _auth (authenticated)
 * Component: PerformanceFeedbacksQuickPage
 */
export const Route = createFileRoute('/_auth/performance/feedbacks/quick')({
  component: PerformanceFeedbacksQuickPage,
})
